import { frontendURL } from '../../../../helper/URLHelper';
import RealEstateCommissionSupportPage from '../pages/RealEstateCommissionSupportPage.vue';
import RealEstateCommissionSupportDetailPage from '../pages/RealEstateCommissionSupportDetailPage.vue';
import RealEstateCommissionInstallmentPage from '../pages/RealEstateCommissionInstallmentPage.vue';
import RealEstateCommissionPlanPage from '../pages/RealEstateCommissionPlanPage.vue';
import { commissionPlanPermissions } from './permissions';

export const supportDashboardRoutes = [
  {
    path: frontendURL('accounts/:accountId/operacao-imobiliaria/apoio'),
    alias: [frontendURL('accounts/:accountId/apoio')],
    name: 'operacao_imobiliaria_apoio',
    component: RealEstateCommissionSupportPage,
    meta: { permissions: commissionPlanPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/apoio/:salesTransactionId/detalhes-processo'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/apoio/:salesTransactionId/detalhes-processo'
      ),
    ],
    name: 'operacao_imobiliaria_apoio_detalhes',
    component: RealEstateCommissionSupportDetailPage,
    meta: { permissions: commissionPlanPermissions },
  },
];

export const supportSheetRoutes = [
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/apoio/:salesTransactionId/planilha-comissao/:installmentId'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/apoio/:salesTransactionId/planilha-comissao/:installmentId'
      ),
    ],
    name: 'operacao_imobiliaria_apoio_parcela',
    component: RealEstateCommissionInstallmentPage,
    meta: { permissions: commissionPlanPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/apoio/:salesTransactionId/planilha-comissao/:installmentId/visualizar'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/apoio/:salesTransactionId/planilha-comissao/:installmentId/visualizar'
      ),
    ],
    name: 'operacao_imobiliaria_apoio_parcela_visualizar',
    component: RealEstateCommissionInstallmentPage,
    meta: { permissions: commissionPlanPermissions },
  },
  {
    path: frontendURL(
      'accounts/:accountId/operacao-imobiliaria/apoio/:salesTransactionId/planilha-comissao'
    ),
    alias: [
      frontendURL(
        'accounts/:accountId/apoio/:salesTransactionId/planilha-comissao'
      ),
    ],
    name: 'operacao_imobiliaria_apoio_planilha_comissao',
    component: RealEstateCommissionPlanPage,
    meta: { permissions: commissionPlanPermissions },
  },
];
